// src/useGoogleMaps.js
import { useState, useEffect } from 'react';
import { GoogleMap, Marker, LoadScript, DirectionsRenderer, InfoWindow } from '@react-google-maps/api';

// كود لكتم أخطاء Google Maps في وحدة التحكم
if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;
  console.error = function(msg, ...args) {
    if (
      typeof msg === 'string' && 
      (msg.includes('Could not load "stats"') || 
       msg.indexOf('https://maps.googleapis.com/maps/api/js') !== -1)
    ) {
      return; // تجاهل أخطاء Google Maps المحددة
    }
    originalConsoleError.apply(console, [msg, ...args]);
  };
}

export const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (window.google && window.google.maps) {
      console.log('google api is already presented');
      setIsLoaded(true);
      return;
    }

    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) return;

    const apiKey = 'AIzaSyAfpEXpKaRnVTfOdRpZaHBhoGCGlsHbVE8';
    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=beta&callback=initMap`;
    script.async = true;
    script.defer = true;

    window.initMap = () => {
      console.log("Google Maps API loaded successfully");
      setIsLoaded(true);
    };

    script.onerror = (e) => {
      console.error("Error loading Google Maps API:", e);
      setLoadError(e);
    };

    document.head.appendChild(script);

    return () => {
      if (window.initMap) {
        window.initMap = null;
      }
    };
  }, []);

  return { isLoaded, loadError };
};

// مكون خريطة محسّن مع خيارات إضافية
const EnhancedGoogleMap = ({ 
  center, 
  zoom, 
  children, 
  mapContainerStyle, 
  ...props 
}) => {
  return (
    <GoogleMap
      center={center || { lat: 29.3759, lng: 47.9774 }}
      zoom={zoom || 12}
      mapContainerStyle={mapContainerStyle || { width: '100%', height: '100%' }}
      options={{
        disableDefaultUI: false,
        zoomControl: true,
        fullscreenControl: false, // تعطيل عناصر تحكم الشاشة الكاملة
        // تعطيل إحصاءات الخريطة التي تسبب الأخطاء
        clickableIcons: false,
        ...props.options
      }}
      {...props}
    >
      {children}
    </GoogleMap>
  );
};

// تصدير جميع المكونات من هذا الملف
export {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  InfoWindow,
  LoadScript,
  EnhancedGoogleMap // إضافة مكون الخريطة المحسّن
};